import React from "react";
import Card, { CardHeader } from "components/card";
import { Checkbox, InputField } from "components/fields";

const NOTIFICATION_OPTIONS = [
  {
    name: "notifyOnVisitor",
    label: "New Visitor Contacts",
    description: "When someone submits the contact form",
  },
  {
    name: "notifyOnPrayer",
    label: "Prayer Requests",
    description: "When someone submits a prayer request",
  },
  {
    name: "notifyOnDonation",
    label: "Donations",
    description: "When someone makes a donation",
  },
];

// Saved with the rest of the page by the Save Changes action.
const NotificationsSection = ({ values, onFieldChange }) => (
  <Card padding="md" className="gap-5">
    <CardHeader
      title="Email Notifications"
      description="Get notified when visitors interact with your Connect page."
    />

    <InputField
      type="email"
      label="Notification Email"
      name="notificationEmail"
      value={values.notificationEmail}
      onChange={(e) => onFieldChange("notificationEmail", e.target.value)}
      placeholder="admin@yourchurch.org"
      hint="Defaults to your account email."
      autoComplete="email"
    />

    <fieldset>
      <legend className="mb-1.5 text-sm font-medium text-fg">Notify Me About</legend>
      <div className="divide-y divide-line rounded-control border border-line">
        {NOTIFICATION_OPTIONS.map((option) => (
          <Checkbox
            key={option.name}
            name={option.name}
            label={option.label}
            description={option.description}
            checked={values[option.name]}
            onChange={(e) => onFieldChange(option.name, e.target.checked)}
            className="p-4"
          />
        ))}
      </div>
    </fieldset>
  </Card>
);

export default NotificationsSection;
